export const LIFENUMFLAG = "LIFENUMFLAG";
export const ADDLIFENUMBER = "ADDLIFENUMBER";
export const ADDLIFEDETAILS = "ADDLIFEDETAILS";
export const ALLLIFEDETAILS = "ALLLIFEDETAILS";
export const LIFE_INS_PRODUCT = "LIFE_INS_PRODUCT";
export const CUST_DETAIL_LIFE = "CUST_DETAIL_LIFE";
export const LIFE_QQ_POST = "LIFE_QQ_POST";
export const LIFE_QUOTE = "LIFE_QUOTE";
export const ERROR_QUOTES_LIFE = "ERROR_QUOTES_LIFE";
export const LIFE_PREV_INS_LIST = "LIFE_PREV_INS_LIST";
export const LIFE_OFF_REQUEST = "LIFE_OFF_REQUEST";
export const RESET_LIFE = "RESET_LIFE";
